/** UI-Labels Druck/Export — FR / AR (zentral für Button + Service). */

export const printExportFr = {
  print: 'Imprimer',
  export: 'Exporter',
  printing: 'Impression...',
  exporting: 'Exportation...',
  print_export: 'Imprimer/Exporter',
  export_pdf: 'Exporter PDF',
  export_excel: 'Exporter Excel',
  export_csv: 'Exporter CSV',
  export_html: 'Exporter HTML',
  print_receipt: 'Imprimer Reçu',
  print_invoice: 'Imprimer Facture',
  print_report: 'Imprimer Rapport',
  success: 'Succès',
  error: 'Erreur',
  export_success: 'Exportation réussie',
  print_success: 'Impression réussie',
  export_failed: 'Échec de l\'exportation',
  print_failed: 'Échec de l\'impression'
};

export const printExportAr = {
  print: 'طباعة',
  export: 'تصدير',
  printing: 'جاري الطباعة...',
  exporting: 'جاري التصدير...',
  print_export: 'طباعة/تصدير',
  export_pdf: 'تصدير PDF',
  export_excel: 'تصدير Excel',
  export_csv: 'تصدير CSV',
  export_html: 'تصدير HTML',
  print_receipt: 'طباعة الإيصال',
  print_invoice: 'طباعة الفاتورة',
  print_report: 'طباعة التقرير',
  success: 'نجح',
  error: 'خطأ',
  export_success: 'تم التصدير بنجاح',
  print_success: 'تم الطباعة بنجاح',
  export_failed: 'فشل التصدير',
  print_failed: 'فشل الطباعة'
};

/**
 * @param {string} key
 * @param {'fr'|'ar'|string} [lang]
 */
export function getPrintExportLabel(key, lang = 'fr') {
  const map = lang === 'ar' ? printExportAr : printExportFr;
  return map[key] || key;
}

/**
 * @param {string} key
 * @returns {{ fr: string, ar: string }}
 */
export function getPrintExportBilingualPair(key) {
  return {
    fr: printExportFr[key] || key,
    ar: printExportAr[key] || key
  };
}
